import { registerPlugin } from '@capacitor/core'
import { Sentry } from '@/services/sentry'

interface AppSettingsPlugin {
  openNotifications(): Promise<void>
}

const appSettingsPlugin = registerPlugin<AppSettingsPlugin>('AppSettings')

export async function openNativeAppSettings(): Promise<void> {
  try {
    await appSettingsPlugin.openNotifications()
  } catch (error) {
    Sentry.captureException(error)
  }
}
